module.exports = __webpack_public_path__ + "static/OficerMexico-1a8ac4d73b3dd76ba03745f748a288b7.png";